module.exports = __webpack_public_path__ + "static/media/slide1.9724388f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupIncludes/assets/slide1.png
// module id = 539
// module chunks = 0